import { API } from 'aws-amplify'
import APIRoutes from '../../api/routes'

export const FETCHINDUSTRYCATEGORIES = 'FETCHINDUSTRYCATEGORIES'
export const UPDATESEARCHCRITERIA = 'UPDATESEARCHCRITERIA'
export const FETCHCOMPANY = 'FETCHCOMPANY'
export const LOADSPINNER = 'LOADSPINNER'
export const CLEARSEARCH = 'CLEARSEARCH'
export const UPDATESELECTEDBUSINESS = 'UPDATESELECTEDBUSINESS'
export const FETCHBUSINESSCOUNT = 'FETCHBUSINESSCOUNT'
export const FETCHBMONITEREDCOMPANIES = 'FETCHBMONITEREDCOMPANIES'
export const HANDLEBUSINESSNAKBAR = 'HANDLEBUSINESSNAKBAR'
export const TOGGLEBUSINESSDETAILS = 'TOGGLEBUSINESSDETAILS'
export const TOGGLESEARCHERROR = 'TOGGLESEARCHERROR'
export const FETCHCLAIMEDBUSINESS = 'FETCHCLAIMEDBUSINESS'
export const LOADINGMONITOREDCOMPANIES = 'LOADINGMONITOREDCOMPANIES'
export const LOADINGCLAIMEDBUSINESSES = 'LOADINGCLAIMEDBUSINESSES'

export const toggleBusinessDetails = (dispatch, status) => {
  dispatch({
    type: TOGGLEBUSINESSDETAILS,
    payload: status,
  })
}

export const fetchIndustryCategories = (dispatch, formData) => {
  API.post('DEFAULT_ENDPOINT', APIRoutes.businessCategories, {
    body: formData,
  }).then(res => {
    dispatch({
      type: FETCHINDUSTRYCATEGORIES,
      payload: res.categories,
    })
  })
}
export const updateSearchCriteria = (dispatch, search) => {
  dispatch({
    type: UPDATESEARCHCRITERIA,
    payload: search,
  })
}

export const toggleSearchError = (dispatch, message) => {
  dispatch({
    type: TOGGLESEARCHERROR,
    payload: message,
  })
}

export const fetchFetchCompany = (dispatch, formData) => {
  loadSpinner(dispatch, true)
  const checkNullData = {
    ...formData,
    address: formData.address ? formData.address : '',
    industry: formData.industry ? formData.industry : '',
  }
  API.post('DEFAULT_ENDPOINT', APIRoutes.searchCompany, {
    body: checkNullData,
  })
    .then(res => {
      loadSpinner(dispatch, false)
      dispatch({
        type: FETCHCOMPANY,
        payload: res,
      })
    })
    .catch(err => {
      dispatch({
        type: FETCHCOMPANY,
        payload: { matched: 0, businessProfiles: [] },
      })
      loadSpinner(dispatch, false)
      toggleSearchError(dispatch, 'Entered Zip code Not found.')
    })
}

export const loadSpinner = (dispatch, status) => {
  dispatch({
    type: LOADSPINNER,
    payload: status,
  })
}

export const handleNotifications = (dispatch, notification) => {
  dispatch({
    type: HANDLEBUSINESSNAKBAR,
    payload: notification,
  })
}

export const clearFullSearch = dispatch => {
  dispatch({
    type: CLEARSEARCH,
  })
}

export const updateSelectedBusiness = (dispatch, business) => {
  dispatch({
    type: UPDATESELECTEDBUSINESS,
    payload: business,
  })
}

export const fetchBusinessCount = dispatch => {
  API.post('DEFAULT_ENDPOINT', APIRoutes.count, {
    body: {
      search: 'all',
    },
  }).then(res => {
    dispatch({
      type: FETCHBUSINESSCOUNT,
      payload: res.count,
    })
  })
}

export const fetchMonitoredBusiness = dispatch => {
  API.get('DEFAULT_ENDPOINT', APIRoutes.userMonitor).then(res => {
    dispatch({
      type: FETCHBMONITEREDCOMPANIES,
      payload: res,
    })
  })
}

export const fetchClaimedBusinesses = dispatch => {
  API.get('DEFAULT_ENDPOINT', APIRoutes.userBusinessIds).then(res => {
    dispatch({
      type: FETCHCLAIMEDBUSINESS,
      payload: { claimedBusinesses: res.companies },
    })
  })
}

export const updateMonitoredBusiness = (dispatch, data) => {
  API.post('DEFAULT_ENDPOINT', APIRoutes.userMonitor, {
    body: data,
  })
    .then(res => {
      handleNotifications(dispatch, {
        type: 'success',
        message: 'Updated Successfully',
        open: true,
      })
      dispatch({
        type: FETCHBMONITEREDCOMPANIES,
        payload: res.details,
      })
    })
    .catch(err => {
      handleNotifications(dispatch, {
        type: 'error',
        message: 'Please try after some time',
        open: true,
      })
    })
}

export const claimBusiness = (formData, callBack) => {
  try {
    callBack({
      loader: true,
      alert: false,
      submitted: false,
    })
    API.post('DEFAULT_ENDPOINT', APIRoutes.ekataVerification, {
      body: formData,
    }).then(res => {
      callBack({
        loader: false,
        alert: true,
        submitted: true,
      })
    })
  } catch (error) {
    callBack({
      loader: false,
      alert: false,
      submitted: false,
    })
  }
}
